    <div class='wrapper'>
        <img src="./assets/icons/gError.png" alt="gError-img">
        <h1>משהו השתבש...</h1>
        <p class="supportPhone">באפשרותך לפנות למוקד התמיכה: 6552*</p>
        <span>או לפתוח פנייה במרכז הסיוע המשרדי (לעובדי המשרד בלבד)</span>
    </div>
